import { ReactComponent as CartCircleIcon } from "../../../assets/icons/cart-circle.svg";
import { ReactComponent as CheckedCircleIcon } from "../../../assets/icons/checked-circle.svg";
import { jsx as _jsx } from "react/jsx-runtime";
export function CartButtonToggle(props) {
  // if the project is not added, show the add to cart button
  // if the project is added to the cart, show the remove from cart button
  if (props.isAlreadyInCart) {
    return /*#__PURE__*/_jsx("div", {
      className: "cursor-pointer",
      "data-testid": "remove-from-cart",
      onClick: props.removeFromCart,
      children: /*#__PURE__*/_jsx(CheckedCircleIcon, {
        className: "w-10"
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: "cursor-pointer",
    "data-testid": "add-to-cart"
    // oonclick adds the project to the cart, sets the current project added to cart and shows the cart notification
    ,
    onClick: () => {
      props.addToCart();
      props.setCurrentProjectAddedToCart(props.project);
      props.setShowCartNotification(true);
    },
    children: /*#__PURE__*/_jsx(CartCircleIcon, {
      className: "w-10"
    })
  });
}